import { captureAttribution, mergedRedirectSearch, readStoredAttribution, NEXTDOOR_REVERSE_PPCID } from './attribution';

export const handleQueryStrings = () => {
    // Runs once at module load. Persist the entry URL's paid-lane params
    // before reading anything, so a later full reload on a bare URL (the ID5
    // TrueLink round trip) can still recover them instead of falling back to
    // the organic defaults for the rest of the session.
    captureAttribution();
    const stored = readStoredAttribution();

    let offer = false;

    let ppcid = '7';
    let cid = 'RateZip';
    let gclid = '';
    let tsid = 'RateZip';
    let phoneNumber = '855-517-0091';
    let changeHeadline = false;
    let isPurchase = false;
    let isCobrand = false;

    const fullUrl = window.location.href;
    const query = new URLSearchParams(window.location.search);
    const entry = new Map();
    for (const [key, value] of query) {
        if (value && !entry.has(key.toLowerCase())) entry.set(key.toLowerCase(), value);
    }
    // Merged so restored attribution propagates back into internal router
    // navigation (this value becomes the router's `search`), not just into
    // outbound redirects.
    let fullQueryString = mergedRedirectSearch() || '?';

    if (fullUrl.includes('/lb')) {
        offer = true;
    }

    if (fullUrl.includes('/xlt')) {
        phoneNumber = '855-931-4803';

        const style = query.get('style') || '';
        if (style === 'new') {
            changeHeadline = true;
        }
    }

    if (fullUrl.includes('/for-purchase')) {
        isPurchase = true;
    }

    // Current URL always wins; stored attribution only fills a gap the URL
    // left, so a mid-session reload keeps the lane that paid for the click.
    const param = (name) => entry.get(name) || stored[name] || '';

    if (fullQueryString.length > 1) {
        cid = param('cid') || cid;
        gclid = param('gclid');

        ppcid = param('ppcid') || ppcid;

        if (gclid.length > 0 && !ppcid) {
            ppcid = '7732';
            cid = gclid;
        }

        const fbclid = param('fbclid');

        if (fbclid) {
            cid = fbclid;
        }

        if (ppcid === NEXTDOOR_REVERSE_PPCID) {
            // Nextdoor appends ndclid to real ad clicks. Never substitute a
            // stale Meta ID, arbitrary cid, or the organic default for it.
            cid = param('ndclid');
            gclid = '';
        }

        tsid = param('tsid') || 'RateZip';
    }

    if (ppcid === '1899') {
        isCobrand = true;
    }

    const queryObject = {
        ppcid,
        cid,
        tsid,
        gclid,
        offer,
        fullQueryString,
        phoneNumber,
        changeHeadline,
        isPurchase,
        isCobrand
    };

    return queryObject;
};
